import * as Y from 'yjs'

// Y.mergeUpdates() degrades to near-exponential time on large input arrays
// because of an upstream bug (https://github.com/yjs/yjs/issues/710). The
// folding strategy below collapses cumulative work back to linear-ish; it's
// the same divide-and-conquer the issue's reporter validated empirically on
// 10k-update batches. 500 is their threshold; below it the direct call wins.
const MERGE_CHUNK_THRESHOLD = 500

export const mergeUpdatesChunked = (updates: Uint8Array[]): Uint8Array => {
    if (updates.length < MERGE_CHUNK_THRESHOLD) return Y.mergeUpdates(updates)

    const half = Math.floor(updates.length / 2)

    return Y.mergeUpdates([mergeUpdatesChunked(updates.slice(0, half)), mergeUpdatesChunked(updates.slice(half))])
}
